/** Time constant for parameter smoothing: ~95 % of a change is done after 3τ = 15 ms. */
export const SMOOTHING_TIME_CONSTANT_S = 0.005;

/** Move an AudioParam to `value` without a click. */
export function smoothTo(context: BaseAudioContext, param: AudioParam, value: number): void {
  param.setTargetAtTime(value, context.currentTime, SMOOTHING_TIME_CONSTANT_S);
}

/** Ramp linearly from wherever the parameter is now to `value` over `seconds`, replacing any ramp in progress. */
export function rampTo(context: BaseAudioContext, param: AudioParam, value: number, seconds: number): void {
  const now = context.currentTime;
  const current = param.value;
  param.cancelScheduledValues(now);
  param.setValueAtTime(current, now);
  param.linearRampToValueAtTime(value, now + seconds);
}

/** A finite number from untrusted settings, clamped to [min, max]; `fallback` otherwise. */
export function numberSetting(value: unknown, fallback: number, min: number, max: number): number {
  const n = typeof value === 'number' && Number.isFinite(value) ? value : fallback;
  return Math.min(max, Math.max(min, n));
}
